import socketio from 'socket.io-client';
//import VueSocketio from 'vue-socket.io';
const uuidv4 = require('uuid/v4');

const socket = socketio('ws://localhost:49443', {
    transports: ['websocket'],
    upgrade: false
});

const callbacks = {};
const handlers = {};

const api = {
    call(action, payload, callback){
        return new Promise((resolve, reject)=>{
            const uuid = uuidv4();
            socket.emit('call', action, payload, uuid);
            callbacks[uuid] = (err, data)=>{
                if(callback){
                    callback(err, data);
                }
                if(err){
                    reject(err);
                }else{
                    resolve(data);
                }
            };
        });
    },
    compatibilityEmit(){
        socket.emit(...arguments);
    },
    compatibilityOn(){
        socket.on(...arguments);
    },
    on(event, handler){
        console.log(`Register API V2 event listener for ${event}`);
        if(!handlers[event]){
            handlers[event] = [];
        }
        handlers[event].push(handler);
    },
};

socket.on('response', (err, data, uuid)=>{
    
    if(callbacks[uuid]){
        console.log('API V2 response handled')
        callbacks[uuid](err, data);
    }else{
        console.log('API V2 response unhandled')
    }
})

socket.on('event', ({event, data})=>{
    console.log(`API V2 event ${event}`, data);
    if(handlers[event]){
        handlers[event].forEach(handler=>{
            handler(data);
        });
    }
})

export {api}

export default {
    install(Vue, options) {
        Vue.prototype.$api = api;
        //Vue.use(VueSocketio, socket);
    },
}
